import { useTranslate } from '@refinedev/core';
import { Button, Checkbox, Form, Input, Modal, Select } from 'antd';
import regex from 'core/constants/Regex';

const RuleViewModal = ({
  stateData,
  stateFunctionHandler,
  functionHandler,
  formData,
}) => {
  const t = useTranslate();
  const {
    reArrangeModalOpen,
    isFilterModalVisible,
    filterList,
    filterListVals,
    copyModalVisible,
    isCopyModalSubmitDisabled,
    ruleGroupListBasedOnType,
  } = stateData;
  const { setCopyModalVisible, setCopyModalRow, setIsCopyModalSubmitDisabled } =
    stateFunctionHandler;
  const {
    onReArrangeroupRuleGroup,
    handleCancel,
    handleCloseFilterModal,
    handleSubmitFilters,
    handleReset,
    toggleFilter,
    handleCopyRulePlan,
    checkCopyModalFormValid,
  } = functionHandler;
  const { copyModalForm } = formData;

  return (
    <>
      <Modal
        title=""
        open={reArrangeModalOpen}
        onOk={onReArrangeroupRuleGroup}
        onCancel={handleCancel}
        maskClosable={false}
      >
        <div>{t('rules.messages.ruleDesc')}</div>
      </Modal>
      <Modal
        title={t('rulePlans.messages.filter')}
        visible={isFilterModalVisible}
        onCancel={handleCloseFilterModal}
        okText="Submit"
        cancelText="Cancel"
        onOk={handleSubmitFilters}
        footer={[
          <Button key="reset" onClick={() => handleReset()}>
            {t('buttons.reset')}
          </Button>,
          <Button key="submit" type="primary" onClick={handleSubmitFilters}>
            {t('buttons.submit')}
          </Button>,
        ]}
        maskClosable={false}
      >
        {filterList?.map((filter) => (
          <div
            key={filter.filter_name}
            style={{ marginBottom: 'var(--spacing-md)' }}
          >
            <div
              style={{ marginBottom: 'var(--spacing-sm)', fontWeight: 'bold' }}
            >
              {filter.filter_name}
            </div>
            <Checkbox.Group
              value={filterListVals[filter.filter_name] || []}
              onChange={(values) => {
                // Update all selected values at once
                const currentValues = filterListVals[filter.filter_name] || [];
                const newValues = values;

                // Find values to add and remove
                const valuesToAdd = newValues.filter(
                  (v) => !currentValues.includes(v)
                );
                const valuesToRemove = currentValues.filter(
                  (v) => !newValues.includes(v)
                );

                // Add new values
                valuesToAdd.forEach((value) =>
                  toggleFilter(value, filter.filter_name)
                );

                // Remove deselected values
                valuesToRemove.forEach((value) =>
                  toggleFilter(value, filter.filter_name)
                );
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 'var(--spacing-sm)',
                }}
              >
                {filter.filter_list.map((option) => (
                  <Checkbox key={option.value} value={option.value}>
                    {option.name.replaceAll(' ', '')}
                  </Checkbox>
                ))}
              </div>
            </Checkbox.Group>
          </div>
        ))}
      </Modal>
      <Modal
        title={t('rulePlans.copyRulePlanModalTitle') || 'Copy Rule Plan'}
        open={copyModalVisible}
        onCancel={() => {
          setCopyModalVisible(false);
          setCopyModalRow(null);
          copyModalForm.resetFields();
          setIsCopyModalSubmitDisabled(true);
        }}
        okText="Submit"
        onOk={handleCopyRulePlan}
        destroyOnClose
        okButtonProps={{
          disabled: isCopyModalSubmitDisabled,
        }}
        maskClosable={false}
      >
        <Form
          form={copyModalForm}
          layout="vertical"
          onValuesChange={(_, allValues) => {
            setIsCopyModalSubmitDisabled(!checkCopyModalFormValid(allValues));
          }}
        >
          <Form.Item
            label={t('rules.ruleName') || 'Rule Name'}
            name="rule_name"
            rules={[
              {
                required: true,
                message:
                  t('rules.messages.ruleName') || 'Please enter Rule Name',
              },
              {
                pattern: regex.noTags,
                message: 'Input must not contain HTML or XML tags.',
              },
            ]}
          >
            <Input
              placeholder={t('rules.messages.ruleName') || 'Enter Rule Name'}
              maxLength={100}
            />
          </Form.Item>
          <Form.Item
            label={t('rules.ruleGroups') || 'Rule Group'}
            name="rule_group_id"
            rules={[
              {
                required: true,
                message:
                  t('rules.messages.ruleGroup') || 'Please Select Rule Group',
              },
            ]}
          >
            <Select
              placeholder={
                t('rules.messages.ruleGroup') || 'Please Select Rule Group'
              }
              maxLength={100}
              options={ruleGroupListBasedOnType.map((item) => {
                console.log(item, 'item for rule group');
                return {
                  label: item?.rule_group_name,
                  value: item?.unique_id,
                };
              })}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default RuleViewModal;
